import { Injectable } from '@angular/core';
import { HttpClient,HttpParams,HttpHeaders } from '@angular/common/http';
import { BehaviorSubject } from 'rxjs';
import { MatSnackBar } from '@angular/material/snack-bar';


@Injectable({
  providedIn: 'root'
})
export class NoteService {
  healthView$: BehaviorSubject<any>;
  landscapeView$: BehaviorSubject<any>;
  allView$:BehaviorSubject<any>;


  constructor(private http: HttpClient,private snackBar: MatSnackBar) { 
    
    this.healthView$ = new BehaviorSubject(null);
    this.landscapeView$ = new BehaviorSubject(null);
    this.allView$ = new BehaviorSubject(null);
  }

  loadNotes(entityid:number,versionid:number,level:string) {
    this.healthView$.next({"loading":true,data:[]});
    this.landscapeView$.next({"loading":true,data:[]});
    this.allView$.next({"loading":true,data:[]});



    let params = new HttpParams()
    .set('entityid', entityid?entityid.toString():'0')
    .set('versionid', versionid?versionid.toString():'0')
    .set('level',level)
    

    this.http.get("/api/data/entityNotes", {params}).subscribe(
      (response: any) => {
        
        // add the dummy initial value
        //let rtn = response;
        //rtn.push({id:0,name:"Initial"})
        let healthView = JSON.parse(response[0].healthView)||[];
        let landscapeView = JSON.parse(response[0].landscapeView)||[];
        let allView = JSON.parse(response[0].allView)||[];
        this.healthView$.next({"loading":false,data:healthView});
        this.landscapeView$.next({"loading":false,data:landscapeView});
        this.allView$.next({"loading":false,data:allView});


      }, (error: any) => {
        // window.location.href = "/login"
        console.log('unable to get Note');
        console.log(error);
      }
    );
  }

  deleteNote(data:String){

    // put on the spinner
    if(data['notetype']=='landscape'){
      let olddata = this.landscapeView$.getValue().data;
      this.landscapeView$.next({"loading":true,data:olddata});
    }else if(data['notetype']=='health'){
      let olddata = this.healthView$.getValue().data;
      this.healthView$.next({"loading":true,data:olddata});
    }else if(data['notetype']=='general'){
      let olddata = this.allView$.getValue().data;
      this.allView$.next({"loading":true,data:olddata});
    }

    // turn the data object into form data to post
    let body = new HttpParams().append("id",data["id"]);
    const headers = new HttpHeaders().set('Content-Type', 'application/x-www-form-urlencoded');
    const options = {
      headers:headers,
      body: body
    }

    this.http.delete("/api/data/entityNotes", options)
    .subscribe(
      (response: any) => {

        if(response.success){
          const rtnid = response["id"];
          if(data['notetype']=='landscape'){
            let data = this.allView$.getValue().data;
            data = data.filter(x => (x["id"] != rtnid && x['notetype']=='landscape'));
            this.landscapeView$.next({"loading":false,data:data.length>0?[data[0]]:[]});
          }else if(data['notetype']=='health'){
            let data = this.allView$.getValue().data;
            data = data.filter(x => (x["id"] != rtnid && x['notetype']=='health'));
            this.healthView$.next({"loading":false,data:data.length>0?[data[0]]:[]});
          }
          let allData = this.allView$.getValue().data;
          allData = allData.filter(x => (x["id"] != rtnid));
          this.allView$.next({"loading":false,data:allData});         
        }

        // this.entities$.next(response);
        //console.log(response);
      }, (error: any) => {
        let message="Unable to delete the Entity"
        let snackBarRef = this.snackBar.open(message, "", { duration: 2000, verticalPosition: 'top', horizontalPosition: 'right', panelClass: 'aip-error-toast' });
        console.log(message + " > " + JSON.stringify(error));

        setTimeout(() => {
          document.location.reload();
        },1000)
      }
    );

  }


  updateNotes(data:object){

    // put on the spinner
    if(data['notetype']=='landscape'){
      let olddata = this.landscapeView$.getValue().data;
      this.landscapeView$.next({"loading":true,data:olddata});
    }else if(data['notetype']=='health'){
      let olddata = this.healthView$.getValue().data;
      this.healthView$.next({"loading":true,data:olddata});
    }else if(data['notetype']=='general'){
      let olddata = this.allView$.getValue().data;
      this.allView$.next({"loading":true,data:olddata});
    }
   

    // turn the data object into form data to post
    let body = new HttpParams();
    Object.keys(data).forEach(x => {
      body = body.append(x,data[x]);
    })

    const headers = new HttpHeaders().set('Content-Type', 'application/x-www-form-urlencoded');

    this.http.post("/api/data/entityNotes", body.toString(), {headers: headers})
    .subscribe(
      (response: any) => {

        if(response.success){
          // update the data if the id is already there, or add if its not
          // is returned as an array with a single row
          const rtnid = response["id"];
          const rtndata = response["data"][0];
          let allFound = false;
          if(data['notetype']=='landscape'){
            this.landscapeView$.next({"loading":false,data:[rtndata]});
            
          }else if(data['notetype']=='health'){
            this.healthView$.next({"loading":false,data:[rtndata]});
          }
          let allData = this.allView$.getValue().data;
          allData.forEach((x,i) => {
            if(x["id"]==rtnid){
              allFound = true;
              allData[i] = rtndata;
            }
          });

          if(!allFound) allData.unshift(rtndata);
          this.allView$.next({"loading":false,data:allData});
        }

        // this.entities$.next(response);
        //console.log(response);
      }, (error: any) => {
        let message="Unable to update the Entity"
        let snackBarRef = this.snackBar.open(message, "", { duration: 2000, verticalPosition: 'top', horizontalPosition: 'right', panelClass: 'aip-error-toast' });
        console.log(message + " > " + JSON.stringify(error));

        setTimeout(() => {
          document.location.reload();
        },1000)
      }
    );
  }

}
